import { createFileRoute } from "@tanstack/react-router";
import { AgeGroupPage } from "@/components/site/age-group";
import { fixturesQuery, newsByCategoryQuery, squadQuery } from "@/lib/site-queries";

export const Route = createFileRoute("/national-team/u15")({
  head: () => ({
    meta: [
      { title: "Argentina U15 | Argentinian.Soccer" },
      { name: "description", content: "Argentina U15 news, fixtures, squad and statistics." },
      { property: "og:title", content: "Argentina U15 | Argentinian.Soccer" },
      { property: "og:url", content: "/national-team/u15" },
    ],
    links: [{ rel: "canonical", href: "/national-team/u15" }],
  }),
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(newsByCategoryQuery("national_team", 4)),
      context.queryClient.ensureQueryData(fixturesQuery("u15", 6)),
      context.queryClient.ensureQueryData(squadQuery("u15")),
    ]),
  component: () => <AgeGroupPage scope="u15" title="Argentina U15" eyebrow="U15" />,
});
